import React from "react";
import SerializedOptions from "./SerializedOptions";
import { StyledContainer } from "./styles";

export const WorkOrderSerialization = ({ workOrderId }) => {
  return (
    <StyledContainer>
      <SerializedOptions workOrderId={workOrderId} />
    </StyledContainer>
  );
};

export default WorkOrderSerialization;
